import { useContext } from "react";
import { OrderActions } from "./orderActions";
import { OrderContext } from "./orderContext";
export function useOrder() {
  const { orderState, dispatch } = useContext(OrderContext);
  const addAddonRecipent = (payload) => {
    dispatch({ type: OrderActions.ADDON_ADD, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };
  const addProductRecipent = (payload) => {
    dispatch({ type: OrderActions.PRODUCT_ADD, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };
  const deleteProductRecipent = (payload) => {
    dispatch({ type: OrderActions.REMOVE_PRODUCT_ITEM, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };
  const resetState = () => {
    dispatch({ type: OrderActions.RESET });
  };

  const deleteRecipentProduct = (payload) => {
    dispatch({ type: OrderActions.DELETE_PRODUCT_ID, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };
  const incressProduct = (payload) => {
    dispatch({ type: OrderActions.INCRESS_PRODUCT_QTY, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };
  const decressProduct = (payload) => {
    dispatch({ type: OrderActions.DECRESS_PRODUCT_QTY, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };
  const celarDiliveryData = (payload) => {
    dispatch({ type: OrderActions.CLEAR_DELIVERY_DATA, payload });
  };
  const duplicateOrder = (payload) => {
    dispatch({ type: OrderActions.DUPLICATE_ORDER, payload });
    dispatch({ type: OrderActions.CALCULATE });
  };

  const replaceOrder = (payload) => {
    dispatch({ type: OrderActions.REPLACE_ORDER, payload });
    dispatch({
      type: OrderActions.SET_DISSCOUNT_DETAILS,
      payload: {
        discount_percentage: 100,
        discount_price: 0,
        custom_reason_for_discount: "Replace order discount",
      },
    });
    dispatch({ type: OrderActions.CALCULATE });
  };

  return {
    celarDiliveryData,
    incressProduct,
    decressProduct,
    deleteRecipentProduct,
    orderState,
    addProductRecipent,
    addAddonRecipent,
    deleteProductRecipent,
    resetState,
    duplicateOrder,
    replaceOrder,
  };
}
